import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import RouterTab from 'vue-router-tab'
import 'vue-router-tab/dist/lib/vue-router-tab.css'
import './assets/style/main.scss'
import './assets/font/font.css'

import antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'




Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(RouterTab);

new Vue({
  router,
  data: function(){
    return {
        isLogined: false,
        fingerNum:''
    }
},
  render: h => h(App)
}).$mount('#app')